import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { UpdateOneShopPreferencesDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { shopQueryKey } from "./use-shop-suspense";

export default function useUpdateShopPreferences(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);
  const mutation = $api.useMutation("patch", "/shops/{shopId}/preferences");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async (body: UpdateOneShopPreferencesDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId } },
        body: {
          ...body,
        },
      });
    },
  });
}

export function useUpdateShopWalletPreferences(shopId: string) {
  const mutation = $api.useMutation(
    "patch",
    "/shops/{shopId}/preferences/wallet",
  );

  return useMutation({
    meta: {
      success: {
        title: "misc.form.success.title",
        message: "misc.form.success.message",
      },
      error: {
        title: "misc.form.error.title",
        message: "misc.form.error.message",
      },
      invalidatesQuery: shopQueryKey(shopId),
    },
    mutationFn: async (data: {
      title?: string;
      backgroundColor?: string;
      logoFile?: File;
      bannerFile?: File;
    }) => {
      const formData = new FormData();

      if (data.logoFile) {
        formData.append("logo", data.logoFile);
      }
      if (data.bannerFile) {
        formData.append("banner", data.bannerFile);
      }

      if (data.title) {
        formData.append("title", data.title);
      }
      if (data.backgroundColor) {
        formData.append("backgroundColor", data.backgroundColor);
      }

      return mutation.mutateAsync({
        params: { path: { shopId } },
        body: formData as any,
      });
    },
  });
}
